import React, { useState, useEffect } from "react";
// External Components
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import Modal from "@mui/material/Modal";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
// Icons
import ErrorIcon from "@mui/icons-material/ErrorOutline";
// Internal Components
import useStyles from "./useStyles";
export default (function (_a) {
    var error = _a.error, handleErrorClose = _a.handleErrorClose;
    var _b = useState(false), open = _b[0], setOpen = _b[1];
    useEffect(function () {
        if (error) {
            setOpen(true);
        }
        else {
            setOpen(false);
        }
    }, [error]);
    var handleClose = function () {
        setOpen(false);
        handleErrorClose();
    };
    var classes = useStyles();
    var InnerModal = function () { return (React.createElement(Grid, { container: true, className: classes.container },
        React.createElement(Grid, { item: true, sm: 12, className: classes.buttonItem },
            React.createElement(Button, { onClick: handleClose, className: classes.buttonLabel }, "Close X")),
        React.createElement(Grid, { item: true, sm: 12 },
            React.createElement(Paper, { className: classes.paper },
                React.createElement(Typography, { align: "center" },
                    React.createElement(ErrorIcon, { className: classes.icon })),
                React.createElement(Typography, { variant: "h1", className: classes.innerText },
                    React.createElement("span", { className: classes.alert }, "Error: "),
                    error))))); };
    return (React.createElement(Modal, { open: open, onClose: handleClose, className: classes.modal },
        React.createElement("div", { className: classes.outerDiv },
            React.createElement(InnerModal, null))));
});
//# sourceMappingURL=index.js.map